import { render, staticRenderFns } from "./CateringOrderUpdatePage.vue?vue&type=template&id=63f7aa18&scoped=true&"
import script from "./CateringOrderUpdatePage.vue?vue&type=script&lang=js&"
export * from "./CateringOrderUpdatePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f7aa18",
  null
  
)

export default component.exports